import React, { memo } from 'react';

/**
 * Depleted power-ups stay tappable: a 0-count tap fires onDepleted(type) so the
 * PlayScreen can open the refill prompt (ad / pack / premium). Fully-disabled
 * buttons were a dead end — players had no route to more power-ups.
 */
function PowerUpBar({ powerUps, powerUpMode, onUndo, onBomb, onRefresh, onDepleted, disabled, canUndo }) {
  const undoDepleted = powerUps.undo <= 0;
  const bombDepleted = powerUps.bomb <= 0;
  const refreshDepleted = powerUps.refresh <= 0;

  return (
    <div className="power-up-bar">
      <button
        className={`power-up-btn power-up-undo${!canUndo || undoDepleted ? ' power-up-disabled' : ''}`}
        onClick={undoDepleted ? () => onDepleted?.('undo') : onUndo}
        disabled={disabled || (!canUndo && !undoDepleted)}
        aria-label={undoDepleted ? 'Get more Undos' : `Undo (${powerUps.undo} remaining)`}
      >
        <span className="power-up-icon">&#8634;</span>
        <span className="power-up-label">Undo</span>
        {powerUps.undo > 0 && <span className="power-up-count">{powerUps.undo}</span>}
        {undoDepleted && <span className="power-up-count power-up-count-zero">+</span>}
      </button>

      <button
        className={`power-up-btn power-up-bomb${powerUpMode === 'bomb' ? ' power-up-active' : ''}${bombDepleted ? ' power-up-disabled' : ''}`}
        onClick={bombDepleted ? () => onDepleted?.('bomb') : onBomb}
        disabled={disabled}
        aria-label={bombDepleted ? 'Get more Bombs' : `Bomb (${powerUps.bomb} remaining)`}
      >
        <span className="power-up-icon">&#128163;</span>
        <span className="power-up-label">Bomb</span>
        {powerUps.bomb > 0 && <span className="power-up-count">{powerUps.bomb}</span>}
        {bombDepleted && <span className="power-up-count power-up-count-zero">+</span>}
      </button>

      <button
        className={`power-up-btn power-up-refresh${refreshDepleted ? ' power-up-disabled' : ''}`}
        onClick={refreshDepleted ? () => onDepleted?.('refresh') : onRefresh}
        disabled={disabled}
        aria-label={refreshDepleted ? 'Get more Refreshes' : `Refresh pieces (${powerUps.refresh} remaining)`}
      >
        <span className="power-up-icon">&#8635;</span>
        <span className="power-up-label">Refresh</span>
        {powerUps.refresh > 0 && <span className="power-up-count">{powerUps.refresh}</span>}
        {refreshDepleted && <span className="power-up-count power-up-count-zero">+</span>}
      </button>
    </div>
  );
}

export default memo(PowerUpBar);
